import * as React from 'react';
import classname from 'classnames';
import { Icon } from '@iyunbao/components';

import {
  BaseWidgetProps,
} from '../utils/type';

type OptionsProps = Array<{
  label: string;
}>;

export interface HelperProps extends BaseWidgetProps {
  options: OptionsProps;
  className?: string;
  style?: React.CSSProperties;
}

const Helper = (props: HelperProps) => {
  const {
    prefixCls = 'crm-helper',
    options,
    className,
  } = props;

  if (!(options && Array.isArray(options) && options.length)) {
    return null;
  }

  const cls = classname(prefixCls, className);

  return (
    <div className={cls}>
      {
        options.map((item, key) => (
          <div
            className={`${prefixCls}-item`}
            key={`item_${key}`}
          >
            <Icon type="xuanzhong" />
            <span className="item-text">{item.label}</span>
          </div>
        ))
      }
    </div>
  );
};

export default Helper;
